import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role } from '@shared/enums/role.enum';
import { DEFAULT_ROUTES_BY_ROLE } from '@shared/records/default-routes-by-role.record';
import { RbsService } from '@auth/services/rbs.service';

export const hasRoleGuard: CanActivateFn = route => {
  const router = inject(Router);
  const rbsService = inject(RbsService);
  const requiredRoles = route.data['roles'] as Role[];

  const selectedUserOrganization = rbsService.selectedUserOrganization();

  if (!selectedUserOrganization) {
    return router.createUrlTree(['/login/auth-landing']);
  }

  if (!Array.isArray(requiredRoles) || !requiredRoles.length) {
    return false;
  }

  const userRole = selectedUserOrganization.role;

  if (!Object.values(Role).includes(userRole)) {
    return false;
  }

  return requiredRoles.includes(userRole) || router.createUrlTree([DEFAULT_ROUTES_BY_ROLE[userRole]]);
};
